import { Environments, HOST_ENV_MAP } from "./Env";

export const getOrigin = () => global.origin;

export const getOriginByEnv = () => {
  let origin;
  if (process.env.APP_ENV === Environments.Staging) {
    origin = `https://mobileweb-stg.parkplus.io`;
  } else if (process.env.APP_ENV === Environments.Production) {
    origin = `https://parkplus.io`;
  } else {
    origin = `http://localhost:3001`;
  }
  return origin;
};
export const apiConfig = (repo: string, version: string | null = null) => {
  let apiHost = HOST_ENV_MAP[repo];
  if (version !== null) apiHost += `/${version}`;
  return apiHost;
};

export enum NATIVE_PERMISSION_TYPE {
  Location = "location",
  Contact = "contact",
  Storage = "storage",
  Notification = "notification",
}

export const DEVICE_BREAK_POINT = {
  desktop: 1200,
  tablet: 991,
  phone: 767,
  smallPhone: 550,
};
